import styled, { css } from 'styled-components';
import { Radio as RadioComponent } from 'antd';

import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

type IButtonProps = {
  isDisabled: boolean;
};

export const Button = styled.div<IButtonProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 12px;

  .ant-radio-checked .ant-radio-inner {
    border-color: #f78e1e !important;
    padding: 0;
  }
  .ant-radio-checked .ant-radio-inner:after {
    background-color: #f78e1e !important;
    border-color: #f78e1e !important;
    padding: 0;
  }

  ${(props: IButtonProps) => {
    if (props.isDisabled) {
      return css`
        pointer-events: none;
        cursor: not-allowed;
        color: #d9d9d9;

        span {
          color: #d9d9d9;
        }
      `;
    }

    return '';
  }};
`;

export const Radio = styled(RadioComponent)`
  font-family: Roboto;
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 100%;
  letter-spacing: 0%;
  color: #8c8c8c;

  @media (max-width: ${BREAKPOINTS.tabletMini}) {
    font-size: 0.625rem !important;
  }
`;

export const Monetary = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 4px;
  color: ${(props) => (props.isChecked ? 'ORANGE' : '#000000')};
`;
